import { useState, useEffect } from 'react'
import SegmentedComponent from '../../../../components/segmented/Segmented.jsx'
import { GetSocialTradingUrlApi } from '../../../../api/request/socialTrading.js'
import { GetMT5AccountsApi } from '../../../../api/request/transfer.js'
import Loader from '../../../../components/Loader.jsx'
import { LuInfo } from 'react-icons/lu'

function CopyTrading() {
    const [value, setValue] = useState('');
    const [options, setOptions] = useState([]);
    const [url, setUrl] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        const fetchAccounts = async () => {
            setIsLoading(true);
            try {
                const { data } = await GetMT5AccountsApi(true);
                if (data?.success && data?.data) {
                    const accountOptions = data.data
                        .filter(account => account.isLive)
                        .map(acc => acc.login.toString());

                    setOptions(accountOptions);
                    if (accountOptions.length > 0) {
                        setValue(accountOptions[0]);
                    } else {
                        setIsLoading(false);
                    }
                } else {
                    setIsLoading(false);
                }
            } catch (error) {
                console.error("Failed to fetch accounts", error);
                setIsLoading(false);
            }
        };
        fetchAccounts();
    }, []);

    useEffect(() => {
        const fetchUrl = async () => {
            if (!value) return;
            setIsLoading(true);
            setUrl('');
            try {
                const { data } = await GetSocialTradingUrlApi({ accountId: value });
                if (data?.success) {
                    setUrl(data?.data);
                }
            } catch (error) {
                setUrl("error");
            } finally {
                setIsLoading(false);
            }
        }
        fetchUrl();
    }, [value]);

    return (
        <div className='w-full h-full'>
            <div className='px-4 py-2'>
                {options.length > 0 && (
                    <SegmentedComponent options={options} value={value} setValue={setValue} />
                )}
            </div>
            {isLoading ? (
                <div className="h-[calc(100vh-150px)] flex justify-center flex-col items-center">
                    <Loader />
                </div>
            ) : (
                url && url !== "error" ? (
                    <iframe
                        src={url}
                        title="Copy Trading"
                        style={{ width: '100%', height: 'calc(100vh - 150px)', border: 'none' }}
                    />
                ) : (
                    <div className='h-[calc(100vh-150px)] flex flex-col items-center justify-center'>
                        <LuInfo size={36} className="text-red-500" />
                        <p className="primary text-center mt-2 flex items-center justify-center">The social trading platform encountered an error. Please verify your account ID and try again</p>
                    </div>
                )
            )}
        </div>
    )
}

export default CopyTrading
